import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { connect } from 'react-redux';
import * as BoxesActions from '../.././actions/EpikBoxes';
import './index.css';
import { bandModelWindowsOption } from '../../utils/constants';
import MyTerminal from '../../components/TtyShell/index';
import logger from 'redux-logger';
import { getPermissionForComponent } from '../../utils/permissionsUtils';

function TwoFAMethodModal({
  isOpen,
  onClose,
  onSubmit,
  defaultMethod = 'email',
  methods = [
    { label: 'Authenticator App', value: '2factorapp' },
    { label: 'SMS', value: 'sms' },
    { label: 'Email', value: 'email' },
  ],
  submitting = false,
}) {
  const [method, setMethod] = useState(defaultMethod);
  useEffect(() => {
    if (isOpen) setMethod(defaultMethod);
  }, [isOpen, defaultMethod]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      modalClassName="twofa-modal"
      contentClassName="twofa-modal-content"
    >
      <ModalHeader toggle={onClose} className="twofa-header">
        <span className="twofa-title">2FA Method</span>
      </ModalHeader>
      <ModalBody className="twofa-body">
        <fieldset className="twofa-fieldset">
          {methods.map((m) => (
            <label key={m.value} className="twofa-option">
              <Input
                type="radio"
                name="twofa-method"
                className="twofa-radio"
                checked={method === m.value}
                onChange={() => setMethod(m.value)}
                disabled={submitting}
              />
              <span className="twofa-label">{m.label}</span>
            </label>
          ))}
        </fieldset>
      </ModalBody>
      <ModalFooter className="twofa-footer">
        <Button outline onClick={onClose} disabled={submitting}>
          Close
        </Button>
        <Button color="primary" onClick={() => onSubmit(method)} disabled={submitting}>
          {submitting ? 'Please wait…' : 'Continue'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

function TwoFAOtpModal({ isOpen, onClose, onSubmit, submitting = false, error }) {
  const [otp, setOtp] = useState('');
  useEffect(() => {
    if (isOpen) setOtp('');
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      modalClassName="twofa-modal"
      contentClassName="twofa-modal-content"
    >
      <ModalHeader toggle={onClose} className="twofa-header">
        <span className="twofa-title">Enter 2FA Code</span>
      </ModalHeader>
      <ModalBody className="twofa-body">
        {error ? <Alert color="danger" className="mb-3">{error}</Alert> : null}
        <div className="otp-row">
          <Label className="otp-label">Enter 2FA Code</Label>
          <Input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter OTP"
            className="otp-input"
            disabled={submitting}
          />
        </div>
      </ModalBody>
      <ModalFooter className="twofa-footer">
        <Button outline onClick={onClose} disabled={submitting}>
          Close
        </Button>
        <Button color="primary" onClick={() => onSubmit(otp)} disabled={submitting || !otp}>
          {submitting ? 'Please wait…' : 'Connect'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

function OobmDevices({
  OobmData,
  selectedRows,
  setSelectedRows,
  user,
  sendFA,
  authenticate2FA,
  getEpikBoxByIdDetails
}) {

  const token = localStorage.getItem('jwtToken') || null;

  const [data, setData] = useState([]);
  const [isTwoFaOpen, setIsTwoFaOpen] = useState(false);
  const [twoFaSubmitting, setTwoFaSubmitting] = useState(false);
  const [isOtpOpen, setIsOtpOpen] = useState(false);
  const [otpSubmitting, setOtpSubmitting] = useState(false);
  const [twoFaContext, setTwoFaContext] = useState(null);
  const [chosenMethod, setChosenMethod] = useState('email');
  const [twoFaId, setTwoFaId] = useState(null);
  const [boxDetails, setBoxDetails] = useState();
  const [termialBox, setTermialBox] = useState();
  const [loading, setLoading] = useState(false);
  const [bandModelWindow, setBandModelWindow] = useState(null);
  const [twoFaRes, setTwoFaRes] = useState(null);

  const OOBMAssignment = getPermissionForComponent('OobmAccess', user.permissionsGroup);


  const [otpError, setOtpError] = useState(null);
  useEffect(() => {
    setData(OobmData?.data ? OobmData?.data : []);
  }, [OobmData]);
  const [terminalProps, setTerminalProps] = useState(null);
  const [increaseTerminalLife, setIncreaseTerminalLife] = useState(false);
  const [forceClose, setForceClose] = useState(false);
  const [time, setTime] = useState(null);

  const onCancelClick = () => {
    setTerminalProps(null);
    setForceClose(false);
    setTermialBox(false)
  };

  const handleCheckboxChange = (item) => {
    const exists = selectedRows.find((r) => r._id === item._id);
    setSelectedRows((prev) => (exists ? prev.filter((r) => r._id !== item._id) : [...prev, item]));
  };

  const handleConnectRow = async (row) => {
    const ln = row?.linkedNumber;
    const box = await getEpikBoxByIdDetails(token, row?._id);
    setBoxDetails(box);
    const port = ln?.usbPort ?? row?.usbPorts?.[0];
    if (!ln || !port) return;

    setTwoFaContext({
      boxId: row?._id,
      deviceId: ln?._id ?? row?._id,
      deviceName: row?.displayName,
      serialNumber: row?.serialNumber,
      vpnAddress: row?.vpnAddress,
      number: ln?.number,
      port: {
        id: port?._id,
        usb: port?.portNo,
        title: port?.title,
        label: port?.customTitle,
        allowTTY: !!port?.allowTTY,
        speed: port?.usbSpeed,
        dataBits: port?.dataBits,
        stopBits: port?.stopBits,
        parity: port?.parity,
        flowControl: port?.flowControl,
      },
    });
    setIsTwoFaOpen(true);
  };

  const buildSendFaPayload = (authPlatform, ctx) => {
    const usbValue = ctx?.port?.title || ctx?.port?.usb || '';
    const boxIdFromRow = ctx?.boxId || '';
    return {
      usb: usbValue,
      authPlatform,
      otp: '',
      loading: false,
      twoFaId: null,
      editOption: false,
      updatedUsbs: {},
      categories: [],
      usbSpeed: '',
      usbCategory: '',
      number: ctx?.number || '',
      title: ctx?.port?.title || '',
      label: ctx?.port?.label || '',
      userId: user?._id || '',
      boxId: boxIdFromRow,
    };
  };

  const buildVerifyPayload = (authPlatform, ctx, otpValue, twoFaIdValue) => {
    const usbValue = ctx?.port?.title || ctx?.port?.usb || '';
    const boxIdFromRow = ctx?.boxId || '';
    return {
      usb: usbValue,
      authPlatform,
      otp: otpValue,
      loading: false,
      twoFaId: twoFaIdValue || null,
      editOption: false,
      updatedUsbs: {},
      categories: [],
      usbSpeed: '',
      usbCategory: '',
      number: ctx?.number || '',
      title: ctx?.port?.title || '',
      label: ctx?.port?.label || '',
      userId: user?._id || '',
      boxId: boxIdFromRow,
    };
  };

  const onMethodChosen = async (method) => {
    setTerminalProps(null);
    setOtpError(null);
    setChosenMethod(method);
    setTwoFaSubmitting(true);

    try {
      if (method === '2factorapp') {
        setTwoFaId(null);
        setIsTwoFaOpen(false);
        setIsOtpOpen(true);
        return;
      }
      // Otherwise (SMS/Email) send the OTP
      const params = buildSendFaPayload(method, twoFaContext);
      const resp = await sendFA(token, params);
      if (resp && (resp._id || resp?.data?._id)) {
        setTwoFaId(resp._id || resp?.data?._id);
      }
      setIsTwoFaOpen(false);
      setIsOtpOpen(true);
    } finally {
      setTwoFaSubmitting(false);
    }
  };

  useEffect(() => {
    if (isOtpOpen) {
      setTerminalProps(null);
    }
  }, [isOtpOpen]);

  const onOtpSubmit = async (otpRaw) => {
    const otp = String(otpRaw || '').trim();
    if (!otp) return;

    setOtpSubmitting(true);
    setLoading(true);
    setOtpError(null);
    setTerminalProps(null);

    try {
      const verifyPayload = buildVerifyPayload(chosenMethod, twoFaContext, otp, twoFaId);
      const res = await authenticate2FA(token, verifyPayload);

      const id = res?._id;

      if (id) {
        const nextWindow =
          verifyPayload.usb === bandModelWindowsOption.webSSH
            ? bandModelWindowsOption.webSSH
            : bandModelWindowsOption.ttyShell;

        setLoading(false);
        if (res) setBandModelWindow(nextWindow);
        setTwoFaRes(res);

        // const resolvedUsb =
        //   twoFaContext?.port?.title || twoFaContext?.port?.usb || verifyPayload.usb;
        // const resolvedVpn = twoFaContext?.vpnAddress || verifyPayload.vpnAddress;

        // if (!resolvedUsb) {
        //   setOtpError('Unable to start terminal: missing USB interface.');
        //   return;
        // }
        setTerminalProps({
          twoFaId: id,
          usb: twoFaContext.port.portNo || '',
          vpnAddress: twoFaContext.vpnAddress,
          number: twoFaContext?.number || verifyPayload.number,
          title: twoFaContext?.port?.title || verifyPayload.title,
          label: twoFaContext?.port?.label || verifyPayload.label,
        });

        setIsOtpOpen(false);
      } else {
        setTerminalProps(null);
        const apiMsg = res?.message || res?.error || res?.data?.message;
        setOtpError(apiMsg || 'Invalid or expired code. Please try again.');
      }
    } catch (e) {
      setLoading(false);
      setTerminalProps(null);
      setOtpError(e?.response?.data?.message || e?.message || 'Authentication failed. Please try again.');
    } finally {
      setOtpSubmitting(false);
    }

    setTermialBox(true)
  };
const hasRole = (u, names = []) => {
  const r = u?.role || u?.roles;
  if (Array.isArray(r)) return r.map(x => String(x).toLowerCase()).some(x => names.includes(x));
  return names.includes(String(r || '').toLowerCase());
};

const canSelect = hasRole(user.role, ['superAdmin', 'companyGroupAdmin']) || OOBMAssignment =='both';
  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
          {canSelect && <th className="cursor-pointer">Select</th>}
          <th className="cursor-pointer">Device Name</th>
          <th className="cursor-pointer">Serial Number</th>
          <th className="cursor-pointer">Vpn Address</th>
          <th className="cursor-pointer">Registration</th>
          <th className="cursor-pointer">BTN</th>
          <th className="cursor-pointer">Category</th>
          <th className="cursor-pointer">Interface</th>
          <th className="cursor-pointer">RInterface State</th>
          <th className="cursor-pointer">TTY</th>
          <th className="cursor-pointer">Speed</th>
          <th className="cursor-pointer">Data Bits</th>
          <th className="cursor-pointer">Stop Bits	</th>
          <th className="cursor-pointer">Parity</th>
          <th className="cursor-pointer">Flow Control</th>
            {user && !user?.company?.oobmTerminalEmulator && (
              <th className="cursor-pointer">Actions</th>
            )}
          </tr>
        </thead>
        <tbody>
          {data?.length ? (
            data.map((oobm) => {
              const ln = oobm?.linkedNumber;
              const up = ln?.usbPort ?? oobm?.usbPorts?.[0];
              if (!ln) return null;
              return (
                <tr key={ln._id}>
                  {canSelect && (
                    <td>
                      <Input
                        type="checkbox"
                        checked={!!selectedRows.find((r) => r._id === ln._id)}
                        onChange={() =>
                          handleCheckboxChange({
                            ...oobm,
                            _id: ln._id,
                            linkedNumber: ln,
                          })
                        }
                      />
                    </td>
                  )}
                  <td>{oobm?.displayName || '-'}</td>
                  <td>{oobm?.serialNumber || '-'}</td>
                  <td>{oobm?.vpnAddress || '-'}</td>
                  <td>{oobm?.registered ? 'Registered' : 'UnRegistered'}</td>
                  <td>{ln?.number || '-'}</td>
                  <td>Default</td>
                  <td>{up?.title || '-'}</td>
                  <td style={{ color: oobm?.vpnAddress ? 'rgb(33 204 33)' : '#ff0000' }}>
                    {oobm?.vpnAddress ? 'Detected' : 'Disconnected'}
                  </td>
                  <td>{up?.allowTTY ? 'Yes' : 'No'}</td>
                  <td>{up?.usbSpeed || '-'}</td>
                  <td>{up?.dataBits || '-'}</td>
                  <td>{up?.stopBits || '-'}</td>
                  <td>{up?.parity || '-'}</td>
                  <td>{up?.flowControl || '-'}</td>
                  {user && !user?.company?.oobmTerminalEmulator && (
                      <td>
                        <Button onClick={() => handleConnectRow(oobm)} color="primary">
                          Connect
                        </Button>
                      </td>
                    )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={15}>
                <Alert rowSpan={12} color="info" className="empty-oobm-cell">
                  {loading ? 'Loading...' : 'No Oobm Found'}
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <TwoFAMethodModal
        isOpen={isTwoFaOpen}
        onClose={() => setIsTwoFaOpen(false)}
        onSubmit={onMethodChosen}
        defaultMethod="email"
        submitting={twoFaSubmitting}
      />

      <TwoFAOtpModal
        isOpen={isOtpOpen}
        onClose={() => setIsOtpOpen(false)}
        onSubmit={onOtpSubmit}
        submitting={otpSubmitting}
        error={otpError}
      />

      {terminalProps?.twoFaId && (
        <Modal isOpen={termialBox} style={{ maxWidth: '70%' }}>
          <div className="modal-actions-overlay">
            <MyTerminal
              twoFaId={terminalProps.twoFaId}
              usb={twoFaContext.port.usb}
              vpnAddress={terminalProps.vpnAddress}
              onCloseClick={onCancelClick}
              setIncreaseTerminalLife={setIncreaseTerminalLife}
              increaseTerminalLife={increaseTerminalLife}
              setTime={setTime}
              forceClose={forceClose}
              did={terminalProps.number}
              usbTitle={terminalProps.title}
              usbLabel={terminalProps.label}
              boxDetails={boxDetails}
            />
            <div className="close-wrap">
              <Button outline onClick={onCancelClick}>Close</Button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.AppState.user,
});

const mapDispatchToProps = (dispatch) => ({
  sendFA: (token, params) => dispatch(BoxesActions.send2FA(token, params)),
  authenticate2FA: (token, params) => dispatch(BoxesActions.authenticate2FA(token, params)),
  getEpikBoxByIdDetails: (token, params) => dispatch(BoxesActions.getEpikBoxById(token, params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OobmDevices);
